export default __webpack_public_path__ + "static/media/icons8-ok-64.2fc95a22.svg";